import { FormEvent, useState, useEffect, useContext } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate, useLocation } from "react-router-dom"
import { AuthContext } from "../../contexts/Auth"
import { ModalEstadoContext } from "../../contexts/ModalEstado"
import { RootStore } from "../../store"
import { setExibirModalRecuperarSenha } from "../../store/modules/modalRecuperarSenha"
import { auth, buscarOrganizacoes } from "../../services/auth"
import { modalOrganizacoesUsuario } from "../../interfaces/auth"
import { io } from "socket.io-client"
import { Button } from "../Styles"
import { AuthGoogle } from "../../helpers/auth"
import { authGoogle } from "../../services/google"
import { toast } from "react-toastify"
import { descriptografarDado } from "../../helpers"
import ModalOrganizacoesUsuario from "../ModalOrganizacoesUsuarios"
import ModalRecuperarSenha from "../ModalRecuperarSenha"
import whatsAppImg from '../../assets/img/whatsapp.png'
import googleImg from '../../assets/img/google.png'
import logoImg from '../../assets/img/logo.png'
import "./auth.css"

function Login() {

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { search, pathname } = useLocation()

  const paramsUrl = new URLSearchParams(search)
  const organizacaoSelecionada = paramsUrl.get('o-s')

  const modalEstadoReceuperarSenha = useSelector(
    (store: RootStore) => store.modalRecuperarSenha
  );

  const { isAuth } = useContext(AuthContext)
  const { modal, modalExibir } = useContext(ModalEstadoContext)

  const [email, setEmail] = useState("")
  const [senha, setSenha] = useState("")
  const [organizacao, setOrganizacao] = useState<string | null>(null)
  const [organizacoesUsuario, setOrganizacoesUsuario] = useState<modalOrganizacoesUsuario[]>([])
  const [processando, setProcessando] = useState(false)
  const [modalRecuperarSenha, setModalRecuperarSenha] = useState(false)

  function cadastrarOrganizacao() {
    return navigate("/novaOrganizacao")
  }

  function exibirModalRecuperarSenha() {
    dispatch(
      setExibirModalRecuperarSenha({
        exibir: true,
      })
    )
  }


  const buscarOrganizacoesUser = async (e: FormEvent) => {

      e.preventDefault()
      setProcessando(true)

      try {

          const payload = {
            email
          }

          const resposta = await buscarOrganizacoes(payload)

          if(resposta.data.length === 1) {
            setOrganizacao(resposta.data[0].idOrganizacao)
            return setProcessando(false)
          }

          modalExibir('ModalOrganizacoesUsuario')
          setOrganizacoesUsuario(resposta.data)

          return setProcessando(false)
        
      } catch (error: any) {

        if (error.response.status === 404) {
          setProcessando(false)
          setEmail('')
          return toast.error('Dados não Encontratos. Tente Novamente')
        }
      }
  }

  async function Auth(e: FormEvent) {
    e.preventDefault()
    setProcessando(true)

    if(organizacao === null) {
      return setProcessando(false)
    }

    const payload = {
      email,
      senha,
      idOrganizacao: organizacao
    }

    try {
      
      const resposta = await auth(payload)

      if (resposta.status === 200) {

        const data = new Date()
        const validadeToken = new Date (data.getTime() + 60 * 60 * 4 * 1000)

        const token = resposta.data.token;
        document.cookie = `authGesttor=${token}; expires=true ${validadeToken.toUTCString()}`

        localStorage.setItem("perfilGesttor", `${resposta.data.perfil}`)
        localStorage.setItem('usuarioGesttor', `${resposta.data.id}`)
        localStorage.setItem("organizacaoGesttor", `${resposta.data.idOrganizacao}`)
        localStorage.setItem("usuarioGesttorAvatar", `${resposta.data.avatar}`)
        localStorage.setItem("organizacaoGesttorAvatar", `${resposta.data.avatarOrganizacao}`)
        localStorage.setItem('authGesttor', 'true')
        localStorage.setItem("permissao", resposta.data.permissoes)

        setProcessando(false)

        const organizacao = resposta.data.idOrganizacao
        const usuario = resposta.data.id

        const socket = io(`${process.env.REACT_APP_API_GESTTOR}?idOrganizacao=${organizacao}`)

        const mensagemDados = {
          usuario
        }

        socket.emit('notificacaoUsuario', organizacao, mensagemDados)

        isAuth()
        
        return navigate("/tarefas")

      }
      
    } catch (error: any) {

      if (error.response.status === 400) {
        setProcessando(false)
        setEmail('')
        setSenha('')
        return toast.error('Dados Inválidos')
      }

      if (error.response.status === 408) {
          setProcessando(false)

          const idCadastroCript = error.response.data.idCadastro;
          const urlHg = process.env.REACT_APP_URL_HG;
          const returnUrl = window.location.origin;

          if (!idCadastroCript) {
              return toast.warning("Licença expirada. Entre em contato com o suporte.");
          }

          const idCadastro = descriptografarDado(idCadastroCript);
          let tempo = 3;

          const toastId = "redirecionamento-cobranca";
          toast.warning(`Licença expirada. Redirecionando para a página de cobrança em ${tempo}s...`, {
              toastId,
              autoClose: 3000,
          });

          const cronometro = setInterval(() => {
              tempo--;

              if (tempo > 0) {
                  toast.update(toastId, {
                      render: `Licença expirada. Redirecionando para a página de cobrança em ${tempo}s...`,
                      type: "warning",
                  });
              } else {
                  clearInterval(cronometro);
                  window.location.href = `${urlHg}/cobranca/${idCadastro}?returnUrl=${returnUrl}`;
              }
          }, 1000);

          return;
      }

      if (error.response.status === 0) {
        setProcessando(false)
        return toast.error('Servidor Indisponível. Tente mais Tarde')
      }

      if (error.response.status === 403) {
        setProcessando(false)
        return toast.error('Usuário sem permissão de acesso. Fale com o administrador da sua empresa')
      }
    }
}

const loginComGoogle = async () => {

    try {

        const resposta = await authGoogle()
 
         window.open(resposta.data, '_blank', 'width=600,height=800')
 
         const listener = (event: MessageEvent) => {
                 
             if (event.origin === process.env.REACT_APP_API_GESTTOR && event.data.type === 'google-auth-sucesso') {
 
               window.removeEventListener('message', listener)
 
               const organizacoes = event.data.data
               const email = event.data.usuario
               const tokens = event.data.token
 
               if(organizacoes.length === 1) {
 
                 return AuthGoogle({
                     idOrganizacao: organizacoes[0].idOrganizacao,
                     email,
                     tokens,
                     isAuth, 
                     navigate
                 })
                 
               }
 
               modalExibir('ModalOrganizacoesUsuario')
               setOrganizacoesUsuario(organizacoes)
               
               return navigate(`${pathname}#${tokens}#${email}`)
 
             } 
         }
 
         const listenerSemDados = (event: MessageEvent) => {
                 
             if (event.origin === process.env.REACT_APP_API_GESTTOR && event.data === 'google-auth-sucesso/sem-dados') {
 
               window.removeEventListener('message', listener)
 
               toast.error('Dados Não Encontratos. Tente com outra Conta')
               
             } 
         }
 
         window.addEventListener('message', listenerSemDados)
 
         window.addEventListener('message', listener)

    } catch (error) {
        
        return toast.error('Falha ao Processar a sua Solicitação')
    }

}

  useEffect(() => {
    setModalRecuperarSenha(modalEstadoReceuperarSenha.exibir)
  }, [modalEstadoReceuperarSenha])

  useEffect(() => {

    const identificarOrganizacao = () => {

      const organizacao  = organizacaoSelecionada

      if(!organizacao) {
        return
      }

      return setOrganizacao(organizacao)
    }

    identificarOrganizacao()

  },[organizacaoSelecionada])

  return (
    <div id="fundoLogin">
      {modal.nome === 'ModalOrganizacoesUsuario' && <ModalOrganizacoesUsuario dados={organizacoesUsuario}/>}
      {modalRecuperarSenha && <ModalRecuperarSenha />}
      <section id="containerEsquerdoLogin">
        <div id="containerFormLogin">
          <img id="logoSistemaGesttor" src={logoImg} alt="logo do Sistema Gesttor"/>
          <span>
            <h1>Login</h1>
            <p>Ainda não tem uma conta? <strong id="cadastreSe" onClick={cadastrarOrganizacao}>Cadastre-se</strong></p>
          </span>

            <div className='containerGoogleAuth' onClick={loginComGoogle}>
                <img src={googleImg} alt='' />
                <p>Login com o Google</p>
            </div>

          <form id="formLogin" onSubmit={organizacao === null ? buscarOrganizacoesUser : Auth }>
            <span className="formCampo">
              <label htmlFor="campoEmail">Usuário</label>
              <input
                type="email"
                id="campoEmail"
                className="email"
                value={email}
                placeholder="insira seu e-mail"
                required
                onChange={(e) => setEmail(e.target.value)}
              ></input>
            </span>
            {organizacao && <span className="formCampo">
              <label htmlFor="campoSenha">Senha</label>
              <input
                type="password"
                id="campoSenha"
                className="senha"
                value={senha}
                placeholder="insira sua senha com 8 dígitos"
                minLength={8}
                maxLength={8}
                required
                onChange={(e) => setSenha(e.target.value)}
              ></input>
            </span>}
            <span>
              <p id="recuperarSenha" onClick={() => exibirModalRecuperarSenha()}>Esqueci Minha Senha</p>
            </span>
            <span id="formEntrar">
              <Button type="submit" isLoading={processando} cor='continuarSucesso'>Continuar</Button>
            </span>
          </form>
        </div>
      </section>
      <section id="containerDireitoLogin"/>
      <a href="https://wa.me/message/YYTHX6J2OKZ3O1" target="_blanck">
        <span id="suporteSistemaGesttor">
              <img src={whatsAppImg} alt="" title="Como podemos te ajudar?"/>
              <p>Como podemos te ajudar?</p>
        </span>
      </a>
    </div>
  );
}

export default Login;
